import React, { useState } from 'react';
import { lastBillBranch, useBranches } from '../../context/BranchContext';
import Modal from '../common/Modal';
import { Spinner } from '../common/Feedback';

/**
 * Pick the one branch a bill belongs to (its prices and stylists). Lists the ticked branches,
 * or every branch when none is ticked.
 */
export default function BranchPickerModal({ title = 'Which branch is this bill for?', subtitle, onPick, onClose, busy }) {
  const { branches, selectedBranches } = useBranches();
  const options = selectedBranches.length ? selectedBranches : branches;
  const remembered = lastBillBranch();
  const [choice, setChoice] = useState(
    options.some((b) => String(b.id) === remembered) ? remembered : String(options[0]?.id || ''),
  );

  return (
    <Modal
      title={title}
      eyebrow="Branch"
      onClose={busy ? undefined : onClose}
      actions={
        <>
          <button type="button" className="dp-btn dp-btn--ghost" onClick={onClose} disabled={busy}>
            Cancel
          </button>
          <button type="button" className="dp-btn" onClick={() => onPick(choice)} disabled={!choice || busy}>
            {busy ? <Spinner small /> : null} Continue
          </button>
        </>
      }
    >
      {subtitle ? <p className="dp-help">{subtitle}</p> : null}
      <p className="dp-help">The branch decides the service prices on this bill.</p>
      <div className="dp-radio-list" role="radiogroup">
        {options.map((b) => (
          <label key={b.id} className={`dp-radio${choice === String(b.id) ? ' is-on' : ''}`}>
            <input
              type="radio"
              name="bill-branch"
              value={b.id}
              checked={choice === String(b.id)}
              onChange={() => setChoice(String(b.id))}
            />
            <span>
              <strong>{b.name}</strong>
              <small>{[b.area, b.city].filter(Boolean).join(', ')}</small>
            </span>
          </label>
        ))}
      </div>
    </Modal>
  );
}
